import { render } from "./FooterComponent.vue?vue&type=template&id=22bb946a"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=22bb946a&lang=css"

import exportComponent from "C:\\Users\\paulinho\\Documents\\GitHub\\liscomp_website_vue3_cli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__